import { ROUTES } from '../App';
import { CAPABILITIES, getEffectiveCapabilities } from './capabilities';

export default function getFirstAccessibleRoute(user) {
    if (!user) return '/venues';
    if (user.isSuperAdmin) return '/venues';
    const effective = getEffectiveCapabilities(user.capabilities || []);
    if (effective.has(CAPABILITIES.BOOKINGS_VIEW)) return '/bookings';
    const route = ROUTES.find((r) => {
        if (!r.capability) return false;
        const caps = Array.isArray(r.capability) ? r.capability : [r.capability];
        return caps.some((c) => effective.has(c));
    });
    return route?.path || '/user/me';
}
